import styled from 'styled-components';
import COLORS from '../../../../common/styles/color-pallete';
import DEVICES from '../../../../common/styles/devices';
import { FONT_FAMILY } from '../../../../common/styles/fontStyles';
import { formatPadding } from '../../../nium-forex/styles';
import { ButtonWrapper } from '../../../../components/common-button/style';

type ParentContainerProps = {
  padding: Array<number>;
  headingDescWidth?: number;
};

export const ParentContainer = styled.div<ParentContainerProps>`
  padding: ${({ padding }) => formatPadding(padding)};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  input[type='file'] {
    opacity: 0 !important;
    position: absolute !important;
  }
  input {
    &:focus {
      font-family: ${FONT_FAMILY.hellix.regular} !important;
    }
    &:not(:placeholder-shown):not(:focus) {
      border-color: ${COLORS.borderGrey};
      font-family: ${FONT_FAMILY.hellix.regular} !important;
    }
    ::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    :-ms-input-placeholder {
      /* IE 10+ */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    :-moz-placeholder {
      /* Firefox 18- */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
  }
  .navigationContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    align-items: center;
    justify-content: center;
    z-index: 2;

    .backButton {
      width: 24px;
      height: 24px;
      grid-column: 1;
      cursor: pointer;
    }
    * {
      justify-self: center;
    }
    @media ${DEVICES.mobileXL} {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      .backButton {
        margin: 0 0 24px -5px;
      }
    }
  }

  @media ${DEVICES.mobileXL} {
    width: 100%;
    margin: 0;
    padding: ${({ padding }) => formatPadding(padding)};
  }

  .notes-field-tooltip {
    height: 24px;
    width: 24px;
  }
`;
export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background-color: ${COLORS.white};
  padding: 24px 24px 40px 24px;
  .closeIcon {
    align-self: end;
    float: right;
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-bottom: 24px;
  }
  @media ${DEVICES.mobileXL} {
    margin: 20px;
    padding: 16px 16px 32px 16px;
  }
`;
export const HelpSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .heading-bold {
    color: ${COLORS.black};
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
    line-height: 26px;
    margin: 8px 0;
  }
  .heading {
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
    max-width: 303px;
    text-align: center;
  }
  .btn-wrapper {
    margin: 32px 0 24px 0;
  }
  @media ${DEVICES.mobileXL} {
    ${ButtonWrapper} {
      width: 280px;
    }
  }
`;

export const EnquiryWrapper = styled.div`
  margin-top: -36px;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .ticket-dropdown {
    margin-bottom: 24px;
  }
  @media ${DEVICES.mobileXL} {
    margin-top: 0;
  }
`;

export const Heading = styled.div`
  font-size: 28px;
  line-height: 38px;
  font-family: ${FONT_FAMILY.hellix.bold};
  margin-bottom: 24px;
  color: ${COLORS.black};
`;

export const SubTitle = styled.div`
  margin: 16px 0 8px 0;
  font-size: 16px;
  line-height: 24px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
`;
export const UploadContainer = styled.div`
  margin-top: 24px;
`;

export const Subheading = styled.div`
  color: ${COLORS.textGrey};
  font-size: 16px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const TransactionWrapper = styled.div`
  margin-bottom: 24px;
`;

export const DateWrapper = styled.div`
  max-width: 256px;
  display: flex;
  justify-content: space-between;
  border: 1px solid ${COLORS.lightBlueDark};
  background: ${COLORS.lightborderBlue};
  padding: 6px 8px;
  border-radius: 2px;
  box-shadow: 0 4px 4px 0 ${COLORS.boxShadowBlackShade};

  .backButton {
    cursor: pointer;
  }
`;
export const TransactionDate = styled.div`
  color: ${COLORS.black};
  font-size: 14px;
  line-height: 22px;
`;
export const FieldWrapper = styled.div`
  margin-left: -8px;
`;

export const TextAreaField = styled.div`
  padding: 5px 0px;
  min-width: 325px;

  .input-header {
    font-size: 14px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.black};
    padding-top: 5px;
  }

  .text-area {
    margin-top: 5px;
    textarea {
      ::-webkit-input-placeholder {
        color: ${COLORS.textDarkGray} !important;
      }
      resize: none !important;
    }
  }
  @media ${DEVICES.mobileXL} {
    min-width: unset;
  }
`;

export const UploadButtonContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  min-height: 120px;
  border: 1px solid ${COLORS.borderGrey};
  margin-top: 8px;
  border-radius: 4px;

  .uploadButtons {
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .cta-text-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .image-file {
    width: 150px;
    height: 100px;
  }

  span {
    margin-top: 6px;
    color: ${COLORS.darkBlue};
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
  }
  @media ${DEVICES.mobileM} {
    width: 130px;
    .image-file {
      width: 120px;
      height: 90px;
    }
  }
  @media ${DEVICES.mobileS} {
    width: 115px;
    .image-file {
      width: 100px;
      height: 80px;
    }
  }
`;

export const UploadFileContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 150px;
  justify-content: flex-start;
  span.error-msg {
    font-size: 12px;
    color: ${COLORS.newerror};
  }
  @media ${DEVICES.mobileS} {
    width: 300px;
  }

  .replace-text-container {
    margin-top: 8px;
    .left-text {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      color: ${COLORS.textLightGrey};
    }
    .replace-text-right {
      float: right;
      font-size: 14px;
      line-height: 22px;
      font-weight: 700;
      color: ${COLORS.darkBlue};
      cursor: pointer;
    }
  }
`;
export const Header = styled.div`
  margin-bottom: 5px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 14px;
  line-height: 20px;
`;
export const AmazeDisclaimerContainer = styled.div`
  margin-top: 24px;
  color: ${COLORS.textLightGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
`;

export const AttachmentNoteContainer = styled.div`
  margin-top: 16px;
  color: ${COLORS.textLightGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  line-height: 20px;
`;

export const SubmitButtonContainer = styled.div`
  margin-top: 48px;
`;
export const DisputeFormDownload = styled.div`
  margin-bottom: 24px;
`;
